export enum CustomerType {
  RETAIL_CUSTOMER = 1,
  PAW_CLUB = 2,
  PET_PRO = 3,
  FORMER_PET_PRO = 4,
  TEST_USER = 5,
  EMPLOYEE = 6,
  PROSPECT = 7,
  INFLUENCER = 10,
}

export const CUSTOMER_TYPE_LABELS = {
  [CustomerType.RETAIL_CUSTOMER]: 'Retail Customer',
  [CustomerType.PAW_CLUB]: 'Paw Club',
  [CustomerType.PET_PRO]: 'petPro',
  [CustomerType.FORMER_PET_PRO]: 'Former petPro',
  [CustomerType.TEST_USER]: 'Test User',
  [CustomerType.EMPLOYEE]: 'Employee',
  [CustomerType.PROSPECT]: 'Prospect',
  [CustomerType.INFLUENCER]: 'Influencer',
} as const;
